import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { useHouseholdId } from '@/shared/hooks'

export function usePantryRealtime() {
  const queryClient = useQueryClient()
  const { householdId } = useHouseholdId()

  useEffect(() => {
    if (!householdId) return

    const channel = supabase
      .channel(`pantry-${householdId}`)
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'ingredients',
          filter: `household_id=eq.${householdId}`,
        },
        () => {
          queryClient.invalidateQueries({ queryKey: ['pantry', 'ingredients'] })
        },
      )
      .subscribe()

    return () => {
      supabase.removeChannel(channel)
    }
  }, [householdId, queryClient])
}
